export default "__VITE_ASSET__B1tT3wGf__"